import React, { useState, useEffect } from 'react';

import useAsync from 'components/hooks/useAsync';
import { showLoader } from 'screens/performanceReview/components/common';
import styled from 'styled-components';
import { FlexContainer, StyledTypography } from 'styles/common';

import { CloseWithStyledIcon } from 'constants/icons';
import theme from 'constants/theme';

import { getDrivers } from 'services/engagement';

const SelectedWrapper = styled.div`
  border: 1px solid ${theme.palette.borders.mediumGrey};
  border-radius: 5px;
  padding: 0.5rem 1rem;
  align-items: center;
  min-height: 38px;
`;

const Driver = styled.span`
  cursor: pointer;
  margin-right: 1rem;
  padding: 4px 12px;
  background: ${(props) => (props.green ? '#d9fae2' : '#e6f6fd')};
  border-radius: 4px;
  font-weight: 400;
  margin-top: 1rem;
  color: ${(props) => (props.green ? 'green' : '#038eef')};
`;

const DriversSelector = ({ prevDrivers = [], onChange = () => {} }) => {
  const [selectedIds, setSelectedIds] = useState(prevDrivers);
  const { data: driversList, run, isLoading, isIdle } = useAsync();

  const handleAdd = (id) => {
    const newSelectedIds = [...selectedIds];
    if (id === 0) {
      // add all
      driversList.map((item) => {
        if (!newSelectedIds.includes(item.uuid)) {
          newSelectedIds.push(item.uuid);
        }
      });
    } else if (!newSelectedIds.includes(id)) {
      newSelectedIds.push(id);
    }
    setSelectedIds(newSelectedIds);
    onChange(newSelectedIds);
  };

  const handleRemove = (id) => {
    const newSelectedIds = selectedIds.filter((itemId) => itemId !== id);
    setSelectedIds(newSelectedIds);
    onChange(newSelectedIds);
  };

  useEffect(() => {
    run(getDrivers());
  }, [run]);

  if (isLoading || isIdle) {
    return showLoader();
  }

  const selectedDrivers = selectedIds.map((itemId) => driversList.filter((item) => item.uuid === itemId)[0]);

  return (
    <>
      <SelectedWrapper style={{ flexWrap: 'wrap' }}>
        {selectedDrivers.map((item) => (
          <Driver key={item.uuid} onClick={() => handleRemove(item.uuid)} withCross>
            {item.displayName} <CloseWithStyledIcon size="tiniest" color="primary" />
          </Driver>
        ))}
      </SelectedWrapper>
      <FlexContainer style={{ alignItems: 'center', flexWrap: 'wrap' }}>
        <StyledTypography customColor={theme.palette.text.label} rightGutter={2} topGutter={2}>
          Add drivers:
        </StyledTypography>
        {driversList.map((item) => (
          <Driver key={item.uuid} onClick={() => handleAdd(item.uuid)}>
            {item.displayName}
          </Driver>
        ))}
        {/* add all driver button */}
        <Driver key="0" onClick={() => handleAdd(0)} green>
          Add all drivers
        </Driver>
      </FlexContainer>
    </>
  );
};

export default DriversSelector;
